const role = [{
  desc: '角色组接口',
  options: {
    url: '/customer/getRoleGroups',
    method: 'post'
  }
}, {
  desc: '角色接口',
  options: {
    url: '/customer/getRoles',
    method: 'post'
  }
}, {
  desc: '角色批量修改接口',
  options: {
    url: '/customer/updateLotRole',
    method: 'post'
  }
}, {
  desc: '角色修改接口',
  options: {
    url: '/customer/updateRole',
    method: 'post'
  }
}, {
  desc: '获取所属角色组的角色 ',
  options: {
    url: '/role/getRolesByRoleGroup',
    method: 'post'
  }
}, {
  desc: '根据商户版本获取角色 ',
  options: {
    url: '/role/queryRolesBySysVersion',
    method: 'post'
  }
}]
export default role



// WEBPACK FOOTER //
// ./src/api/role.js